import React from 'react';
import Footer from '../../components/Footer';
import UKGOV from "../../assets/ap2.pdf";
import { FaDownload, FaUniversity } from 'react-icons/fa';

const UkGov = () => {
  const handleDownloadPDF = () => {
    // Create a temporary link element
    const link = document.createElement('a');
    link.href = UKGOV;
    link.download = 'Uttarakhand_Government_Letter.pdf';
    
    // Trigger the download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="w-full min-h-screen bg-gradient-to-b from-[#f8f9fa] to-white mt-[70px] sm:mt-[170px]">
      {/* Header Section */}
      <div className="container mx-auto px-4 py-12">
        <div className="text-center">
          <h2 className="mb-4 text-3xl md:text-5xl tracking-tight font-extrabold text-[#0e4d38] flex items-center justify-center gap-4">
            <FaUniversity className="text-[#0e4d38]" />
            Uttarakhand Government Letter
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto mt-4 text-center">
            Official recognition document showcasing the legal status of Maya Devi University
          </p>
        </div>
      </div>

      {/* Document Preview Section */}
      <div className="container mx-auto px-4 py-8">
        <div className="bg-white shadow-xl rounded-lg overflow-hidden max-w-4xl mx-auto">
          <div className="p-6 bg-[#0e4d38] text-white flex justify-between items-center">
            <h3 className="text-xl font-semibold">
              Government Recognition Document
            </h3>
            <button 
              onClick={handleDownloadPDF}
              className="flex items-center gap-2 bg-white text-[#0e4d38] px-4 py-2 rounded-full hover:bg-gray-100 transition duration-300"
            >
              <FaDownload />
              Download PDF
            </button>
          </div>
          
          {/* PDF Preview Placeholder */}
          <div className="p-6 text-center">
            <div className="bg-gray-100 rounded-lg p-8 flex flex-col items-center">
              <FaUniversity className="text-6xl text-[#0e4d38] mb-4" />
              <h4 className="text-xl font-semibold mb-2">Official Document</h4>
              <p className="text-gray-600 mb-4">
                The government recognition letter is an official document verifying 
                the legal status of Maya Devi University.
              </p>
              <button 
                onClick={handleDownloadPDF}
                className="bg-[#0e4d38] text-white px-6 py-2 rounded-full hover:bg-[#0e4d38]/90 transition duration-300 flex items-center gap-2"
              >
                <FaDownload />
                Download Official Document
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Additional Information Section */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="bg-white shadow-lg rounded-lg p-6">
            <h3 className="text-xl font-semibold text-[#0e4d38] mb-4">
              Legal Recognition
            </h3>
            <p className="text-gray-600">
              The Uttarakhand Government letter confirms the university's 
              legal status under the state's private university regulations.
            </p>
          </div>
          <div className="bg-white shadow-lg rounded-lg p-6">
            <h3 className="text-xl font-semibold text-[#0e4d38] mb-4">
              Authenticity
            </h3>
            <p className="text-gray-600">
              This document serves as an official testament to Maya Devi 
              University's compliance with state educational standards.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default UkGov;